/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_How_UnilateralInputs */

const en_us2_exercise_sheet_how_unilateral = /** @type {(inputs: Exercise_Sheet_How_UnilateralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One side at a time: log the reps of ONE side. Volume (load × reps) counts both sides. Did only one side? Mark the side on the set.`)
};

const pt_br2_exercise_sheet_how_unilateral = /** @type {(inputs: Exercise_Sheet_How_UnilateralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um lado de cada vez: registre as repetições de UM lado. O volume (peso × repetições) conta os dois lados. Fez só um lado? Marque o lado na série.`)
};

const es_419_exercise_sheet_how_unilateral = /** @type {(inputs: Exercise_Sheet_How_UnilateralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un lado a la vez: registra las repeticiones de UN lado. El volumen (peso × repeticiones) cuenta los dos lados. ¿Hiciste solo un lado? Marca el lado en la serie.`)
};

const pt_pt2_exercise_sheet_how_unilateral = /** @type {(inputs: Exercise_Sheet_How_UnilateralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um lado de cada vez: regista as repetições de UM lado. O volume (peso × repetições) conta os dois lados. Fizeste só um lado? Marca o lado na série.`)
};

const fr_fr2_exercise_sheet_how_unilateral = /** @type {(inputs: Exercise_Sheet_How_UnilateralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un côté à la fois : note les répétitions d'UN côté. Le volume (charge × rép.) compte les deux côtés. Tu n'as fait qu'un côté ? Indique le côté sur la série.`)
};

const de_de2_exercise_sheet_how_unilateral = /** @type {(inputs: Exercise_Sheet_How_UnilateralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Seite nach der anderen: Trag die Wiederholungen EINER Seite ein. Das Volumen (Gewicht × Wdh.) zählt beide Seiten. Nur eine Seite gemacht? Markiere die Seite am Satz.`)
};

const it_it2_exercise_sheet_how_unilateral = /** @type {(inputs: Exercise_Sheet_How_UnilateralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un lato alla volta: registra le ripetizioni di UN lato. Il volume (carico × ripetizioni) conta entrambi i lati. Hai fatto un solo lato? Segna il lato nella serie.`)
};

/**
* | output |
* | --- |
* | "One side at a time: log the reps of ONE side. Volume (load × reps) counts both sides. Did only one side? Mark the side on the set." |
*
* @param {Exercise_Sheet_How_UnilateralInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_how_unilateral = /** @type {((inputs?: Exercise_Sheet_How_UnilateralInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_How_UnilateralInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_how_unilateral(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_how_unilateral(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_how_unilateral(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_how_unilateral(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_how_unilateral(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_how_unilateral(inputs)
	return en_us2_exercise_sheet_how_unilateral(inputs)
});
export { exercise_sheet_how_unilateral as "exercise-sheet.how_unilateral" }